// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAyiq54VottKAJK8VGDUf6YaRs2VQgD2j4",
    authDomain: "projectnow-c5dba.firebaseapp.com",
    databaseURL: "https://projectnow-c5dba.firebaseio.com",
    projectId: "projectnow-c5dba",
    storageBucket: "projectnow-c5dba.appspot.com",
    messagingSenderId: "999351132059",
    appId: "1:999351132059:web:1d7b76282f609b53a0cb3e",
    measurementId: "G-J39VETQX75",
    vapidKey: 'BHGViDhmnqCL1QViWh0GqkD2104x7clPlwG0NGiWGPPxCfqIPK6G6JoLSvE3MbucaG61R3iXXjfrniTqaayh0A0'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
